module.exports = __webpack_public_path__ + "static/media/video.fdd3baa9.svg";